import React from 'react';
import { Modal } from 'antd-mobile';
import uniqueString from 'unique-string';
import './index.scss';

const Solicys = [
  {value:4, code:"jp_ppP", name:"精品三分屏"},
  {value:5, code:"jp_PP_SV", name:"精品学生+VGA"},
  {value:6, code:"jp_single", name:"精品单屏"},
  {value:7, code:"jp_Pp_TV", name:"精品老师+VGA (画中画)"},
  {value:8, code:"jp_PP_TV", name:"精品老师+VGA (左右)"},
  {value:9, code:"jp_Pp_TS", name:"精品老师+学生(画中画)"},
  {value:10, code:"jp_PP_TS", name:"精品老师+学生(左右)"},
]

const Pipposes = [
  {value:"lu", name:"左上"},
  {value:"ru", name:"右上"},
  {value:"ld", name:"左下"},
  {value:"rd", name:"右下"},
]

const LayoutModal = (props) => {
    
    const { visible, value = [], onChange, onModalChange } = props;

    const [ solicyCode, pipCode ] = value;

    const handleChange = (solicy, pippose) => {
      const [ obj ] = Solicys.filter(item => item.code === solicy);
      let pip = 'lu';
      if (obj && onChange) {
        if (pippose) {
          pip = pippose;
        }
        onChange(obj.code, [ obj.value, pip ]);
      }
    }
    return (
        <Modal
        className="layout-modal"
        style={{ width: '63.7vw' }}
        transparent
        visible={visible}
        onClose={onModalChange}
        title="布局"
      >
        <div className="layout-content">
          {/* 精品单屏 */}
          <div className={`layout-card single ${solicyCode === 'jp_single' && 'on'}`} onClick={() => handleChange('jp_single')}>
            <span className="part"><label>老师全景</label></span>
          </div>
          {/* 精品三分屏 */}
          <div className={`layout-card three-part ${solicyCode === 'jp_ppP' && 'on'}`} onClick={() => handleChange('jp_ppP')}>
            <span className="part part1"><label>课件</label></span>
            <span className="part part2"><label>学生全景</label></span>
            <span className="part part3"><label>老师全景</label></span>
          </div>
          {/* 精品学生+VGA */}
          <div className={`layout-card two-part ${solicyCode === 'jp_PP_SV' && 'on'}`} onClick={() => handleChange('jp_PP_SV')}>
            <span className="part part1">
              <div className="part-linefeed">
                <div>学生全景</div>
                <div>老师全景</div>            
              </div>
            </span>
            <span className="part part2">
              <div className="part-linefeed">
                <div>课件</div>
                <div>课件</div>
              </div>
            </span>
          </div>
          {/* 精品老师+VGA (左右) */}
          <div className={`layout-card two-part ${solicyCode === 'jp_PP_TV' && 'on'}`} onClick={() => handleChange('jp_PP_TV')}>
            <span className="part part1">
              <div className="part-linefeed">
                <div>老师全景</div>
                <div>老师全景</div>
              </div>
            </span>
            <span className="part part2">
              <div className="part-linefeed">
                  <div>课件</div>
                  <div>课件</div> 
                </div>
            </span>
          </div>
          {/* 精品老师+学生(左右) */}
          <div className={`layout-card two-part ${solicyCode === 'jp_PP_TS' && 'on'}`} onClick={() => handleChange('jp_PP_TS')}>
            <span className="part part1">
              <label>老师全景</label>
            </span>
            <span className="part part2">
                <div className="part-linefeed">
                  <div>学生全景</div>
                  <div>课件</div> 
                </div>
            </span>
          </div>
          {/* 精品老师+VGA (画中画) */}
          <div className={`layout-card single pip ${solicyCode === 'jp_Pp_TV' && 'on'}`} onClick={() => handleChange('jp_Pp_TV')}>
            <span className="part"><label>老师全景</label></span>
            {
              Pipposes.map((item, index) => (
                <span key={uniqueString()} className={`p p${index+1} ${solicyCode === 'jp_Pp_TV' && pipCode === item.value && 'on'}`}  onClick={(e) => { e.stopPropagation();handleChange('jp_Pp_TV', item.value) }}><label>课件 课件</label></span>
              ))
            }
          </div>
          {/* 精品老师+学生(画中画) */}
          <div className={`layout-card single pip ${solicyCode === 'jp_Pp_TS' && 'on'}`} onClick={() => handleChange('jp_Pp_TS')}>
              <span className="part"><label>老师全景</label></span>
              {
                Pipposes.map((item, index) => (
                  <span key={uniqueString()} className={`p p${index+1} ${solicyCode === 'jp_Pp_TS' && pipCode === item.value && 'on'}`} onClick={(e) => {e.stopPropagation();handleChange('jp_Pp_TS', item.value)}}><label>学生全景 课件</label></span>
                ))
              }
          </div>
        </div>
      </Modal>

    )
}

export default LayoutModal;